<!-- @format -->
<script>
  export let images;
  export let activeImageIndex;
  export let onModalClose;

  const onSliderButtonClick = (direction) => {
    if (direction === "left" && activeImageIndex > 0) {
      activeImageIndex--;
    } else if (direction === "right" && activeImageIndex < images.length - 1) {
      activeImageIndex++;
    }
  };

  const changeImage = (i) => {
    activeImageIndex = i;
  };
</script>

<div class="gallery-modal">
  <div class="active-image-wrapper container-fluid container-fluid-max-xl">
    <div class="row h-100">
      <div class="col-12">
        <div class="image-container">
          <img
            src={images[activeImageIndex]}
            alt="active pic"
            class="active-image" />
          <button class="close-btn" on:click={onModalClose()}>
            <img
              src="https://liferay-cms.hyperin.com/documents/d/kista-galleria/close-icon"
              alt="close icon"
              class="close-icon" />
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="slider-wrapper">
    <div class="container-fluid container-fluid-max-xl">
      <div class="row h-100">
        <div class="col-12 slider">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div class="arrow-btn" class:disabled={activeImageIndex == 0} on:click={() => onSliderButtonClick("left")}>
            <img
              src="/theme/citycon2023/images/arrow-down-black.png"
              class="arrow-icon arrow-left"
              alt="arrow left" />
          </div>
          <div>
            {#each images as image, index}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <img
                src={image}
                alt="slider"
                class="slider-image"
                on:click={() => {
                  changeImage(index);
                }}
                class:unselected-image={image !== images[activeImageIndex]} />
            {/each}
          </div>
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div class="arrow-btn" class:disabled={images.length - 1 == activeImageIndex} on:click={() => onSliderButtonClick("right")}>
            <img
              src="/theme/citycon2023/images/arrow-down-black.png"
              class="arrow-icon arrow-right"
              alt="arrow right"
              width="36" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .disabled{
    opacity: 0;
  }
  .slider-wrapper {
    height: 20%;
    display: flex;
    align-items: center;
  }
  .image-container {
    border: 1px solid;
    background-color: #ffffff;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .gallery-modal {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9999;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
  }
  .active-image-wrapper {
    padding-top: 64px;
    height: 80%;
  }
  .active-image {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .slider {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .slider-image {
    margin-left: 10px;
    margin-right: 10px;
    object-fit: cover;
    width: 64px;
    height: 64px;
    cursor: pointer;
  }
  .slider-image:hover {
    transform: scale(1.1);
    transition: all 0.5s ease;
  }
  .close-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    right: 10px;
    top: 10px;
    position: absolute;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.5);
    height: 40px;
    width: 40px;
    border: none;
  }
  .close-btn:hover {
    transform: scale(1.1);
    transition: all 0.5s ease;
  }
  .close-icon {
    filter: invert(100%);
    height: 25px;
    width: auto;
  }
  .arrow-btn {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: white;
    display: flex;
  }
  .arrow-btn:hover {
    transform: scale(1.1);
    transition: all 0.5s ease;
  }
  .arrow-icon {
    cursor: pointer;
  }
  .arrow-left {
    transform: rotate(90deg);
  }
  .arrow-right {
    transform: rotate(270deg);
  }
  .unselected-image {
    opacity: 0.3;
  }
</style>
